<template>
  <div class="card">
    <div class="card-header">
      <h6>Crear nuevo usuario con acceso a la plataforma</h6>
    </div>
    <div class="card-body px-4">
      <div class="row">
        <div class="col">
          <label>Nombre</label>
          <input type="text" class="form-control" v-model="form.name">
          <label>Correo electrónico</label>
          <input type="text" class="form-control" v-model="form.email">
          <label>Porcentaje de comisión</label>
          <input type="number" class="form-control" v-model="form.percentage">
        </div>
        <div class="col">
          <label>Contraseña</label>
          <input type="text" class="form-control" v-model="form.password">
          <label>Rol</label>
          <select type="text" class="form-control" v-model="form.type">
            <option value="agent_leads">Agente Leads</option>
            <option value="agent_ftd">Agente FTD</option>
            <option value="agent_retention">Agente Retencion</option>
            <option value="supervisor_ftd">Supervisor FTD</option>
            <option value="supervisor_retention">Supervisor Retencion</option>
            <option value="administrator">Administrador del sistema.</option>
          </select>
        </div>

      </div>

      <div class="mt-4">
        <label>
          IP permitida para iniciar sesión
          <span v-if="form.type !== 'administrator'" class="text-danger">*</span>
        </label>
        <p class="text-xs text-secondary mb-2">
          <template v-if="form.type === 'administrator'">
            El administrador no se restringe por IP (puede dejarse vacío).
          </template>
          <template v-else>
            El agente solo podrá iniciar sesión desde esta IP. Es obligatorio asignarla.
          </template>
        </p>
        <input type="text" class="form-control" placeholder="Ej. 192.168.0.1" v-model="allowedIp">
      </div>

      <button class="btn bg-gradient-success mt-4 w-100" @click="create"> Crear nuevo agente</button>
    </div>
  </div>
</template>

<script>
import {post} from "@/utils/httpRequest";

export default {
  name: "index",
  data: () => ({
    allowedIp: '',
    form: {
      name: '',
      email: '',
      percentage: 0,
      password: '',
      type: '',
    }
  }),
  methods: {
    async create(){
      if(this.form.name !== '' && this.form.email !== '' && Number(this.form.percentage) >= 0 && this.form.type !== '' && this.form.password !== ''){
        // IP obligatoria para staff. El administrator queda exento (failsafe).
        if(this.form.type !== 'administrator' && !this.allowedIp.trim()){
          this.$swal({
            html: 'Tenés que asignar una IP para este agente.',
            icon: 'warning',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
          return
        }
        this.form.percentage = Number((this.form.percentage/100).toFixed(2))
        const {data} = await post('users/create', {...this.form, allowed_ip: this.allowedIp.trim()})
        if(data === 200){
          this.$swal({
            html: 'Procesado con éxito',
            icon: 'success',
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.$router.push('users')
        }
      }
    }
  }
}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
